import React from 'react'
import Row from './Row'

export default function Table({ companies, loading }) {
  return (
    <>
      <table className="dome-table dome-table-striped dome-full-width">
        <thead>
          <tr>
            <th>Select</th>
            <th>Company Name</th>
            <th>Alias</th>
            <th>Logo</th>
            <th>Type</th>
            <th>Approval status</th>
          </tr>
        </thead>
        {loading && (
          <tbody>
            <LoaderWrapper />
          </tbody>
        )}
        {!loading && <tbody>{companies && companies.map((company, key) => <Row key={key} company={company} />)}</tbody>}
      </table>
    </>
  )
}

const LoaderWrapper = () => {
  return (
    <>
      <tr>
        <td colSpan={6}>
          <div className="dome-d-flex dome-full-width dome-justify-center">
            <i className="fa fa-spinner fa-spin" style={{ fontSize: '24px' }}></i>
          </div>
        </td>
      </tr>
    </>
  )
}
